(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zelle-featured"]) return;
  try {
    
function setupZelleCampaign(root){
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 root.querySelectorAll('.zelle-campaign-video').forEach(video=>{
  if(video.dataset.campaignReady)return;
  video.dataset.campaignReady='true';video.muted=true;
  let started=false;
  if('IntersectionObserver' in window){
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting){video.pause();return;}
    if(!started&&!reduced.matches&&!document.hidden){started=true;video.play().catch(()=>{});}
   }),{threshold:0.35});observer.observe(video);
  }
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});
  reduced.addEventListener('change',()=>{if(reduced.matches)video.pause();});
 });
}
setupZelleCampaign(document);
document.addEventListener('shopify:section:load',event=>setupZelleCampaign(event.target));

  } catch(e) { console.error(e); }
})();
})();
